import { render } from "./DashboardContractModel.vue?vue&type=template&id=dcff9972&scoped=true"
import script from "./DashboardContractModel.vue?vue&type=script&lang=js"
export * from "./DashboardContractModel.vue?vue&type=script&lang=js"

import "./DashboardContractModel.vue?vue&type=style&index=0&id=dcff9972&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcff9972"]])

export default __exports__